import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    if (!email) {
      setSubscribeStatus('error');
      return;
    }

    setSubscribeStatus('submitting');

    try {
      const formBody = new URLSearchParams();
      formBody.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d69ho4lt1k61917cm8hg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubscribeStatus('success');
        setEmail('');
        setTimeout(() => setSubscribeStatus('idle'), 3000);
      } else {
        setSubscribeStatus('error');
      }
    } catch (error) {
      setSubscribeStatus('error');
    }
  };

  return (
    <footer className="bg-black text-white pt-24 pb-16 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Upper Section */}
        <div className="grid grid-cols-12 gap-16 mb-16">
          {/* Left Column */}
          <div className="col-span-5">
            <h3 className="text-5xl font-extralight mb-6">Stay Connected</h3>
            <p className="text-white/70 mb-12 text-base">
              Follow our journey in creating exceptional iOS experiences
            </p>
            
            <form id="newsletter-form" onSubmit={handleSubscribe} data-readdy-form>
              <div className="mb-6">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="w-full bg-transparent border-0 border-b border-white/30 text-white placeholder-white/50 py-3 text-base focus:outline-none focus:border-white/60 transition-colors"
                />
              </div>
              <button
                type="submit"
                disabled={subscribeStatus === 'submitting'}
                className="bg-white text-black px-8 py-3 rounded-full font-medium hover:bg-white/90 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                {subscribeStatus === 'success' ? 'Subscribed!' : 'Subscribe'}
                <i className="ri-arrow-right-line"></i>
              </button>
              {subscribeStatus === 'error' && (
                <p className="text-red-400 text-sm mt-2">Please enter a valid email.</p>
              )}
            </form>
          </div>

          {/* Middle Column */}
          <div className="col-span-3">
            <h4 className="text-sm uppercase tracking-wider text-white/60 mb-6">PRODUCTS</h4>
            <ul className="space-y-4">
              <li><a href="#products" className="text-white/80 hover:text-white transition-colors underline text-base cursor-pointer">VPN Protection</a></li>
              <li><a href="#products" className="text-white/80 hover:text-white transition-colors underline text-base cursor-pointer">Smart Cleaner</a></li>
              <li><a href="#products" className="text-white/80 hover:text-white transition-colors underline text-base cursor-pointer">Features</a></li>
              <li><a href="#products" className="text-white/80 hover:text-white transition-colors underline text-base cursor-pointer">Updates</a></li>
            </ul>
          </div>

          {/* Right Column */}
          <div className="col-span-4">
            <h4 className="text-sm uppercase tracking-wider text-white/60 mb-6">CONTACT</h4>
            <div className="space-y-3 mb-10">
              <div>
                <p className="text-xs text-white/60 mb-1">Number</p>
                <p className="text-base text-white">+1 6814413445</p>
              </div>
              <div>
                <p className="text-xs text-white/60 mb-1">Email</p>
                <p className="text-base text-white">support@loco-doo.com</p>
              </div>
            </div>

            <h4 className="text-sm uppercase tracking-wider text-white/60 mb-6">ADDRESS</h4>
            <div className="text-white leading-relaxed text-base">
              <p>Augusta Senoe 1</p>
              <p>Slavonski Brod, 35000</p>
              <p>Croatia</p>
            </div>
          </div>
        </div>

        {/* Lower Section */}
        <div className="pt-12 border-t border-white/15">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white/70 hover:text-white transition-colors underline text-sm cursor-pointer">LinkedIn</a>
              <span className="text-white/30">•</span>
              <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white/70 hover:text-white transition-colors underline text-sm cursor-pointer">Twitter</a>
              <span className="text-white/30">•</span>
              <a href="https://github.com" target="_blank" rel="nofollow noopener noreferrer" className="text-white/70 hover:text-white transition-colors underline text-sm cursor-pointer">GitHub</a>
            </div>

            <p className="text-white/60 text-sm">© 2025 LOCO d.o.o. All rights reserved</p>

            <div className="flex items-center gap-4">
              <a href="#" className="text-white/70 hover:text-white transition-colors underline text-sm cursor-pointer">Privacy Policy</a>
              <span className="text-white/30">•</span>
              <a href="#" className="text-white/70 hover:text-white transition-colors underline text-sm cursor-pointer">Terms of Service</a>
            </div>
          </div>
        </div>

        {/* Readdy Link */}
        <div className="mt-8 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-white/50 hover:text-white/70 transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}